module.exports = __webpack_public_path__ + "img/05.172ae5c1.png";